import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import './ModalCrearUsuario.css';

function ModalValidacionServicioForm({ isOpen, onClose, onSave, row, usuarios, estados }) {
  const [form, setForm] = useState({
    id_usuario: '',
    reclamo: '',
    monto: '',
    observaciones: '',
    estado: '1',
  });

  useEffect(() => {
    if (!isOpen) return;
    if (row) {
      const m = row.monto;
      const montoStr =
        m != null && m !== '' ? String(Number(m)) : '';
      setForm({
        id_usuario: row.id_usuario != null ? String(row.id_usuario) : '',
        reclamo: row.reclamo || '',
        monto: montoStr,
        observaciones: row.observaciones || '',
        estado: row.estado != null ? String(row.estado) : '1',
      });
    } else {
      setForm({
        id_usuario: '',
        reclamo: '',
        monto: '',
        observaciones: '',
        estado: '1',
      });
    }
  }, [isOpen, row]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.id_usuario) return alert('Seleccione el colaborador.');
    if (!form.reclamo.trim()) return alert('Ingrese el reclamo.');
    const montoNum = parseFloat(String(form.monto).replace(',', '.'));
    if (form.monto === '' || Number.isNaN(montoNum) || montoNum < 0) return alert('Ingrese un monto válido (≥ 0).');
    const payload = {
      id_usuario: Number(form.id_usuario),
      reclamo: form.reclamo.trim(),
      monto: montoNum,
      observaciones: form.observaciones.trim() || null,
    };
    if (row) {
      payload.id = row.id;
      payload.estado = Number(form.estado);
    }
    try {
      await onSave(payload);
      onClose(true);
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || 'Error al guardar.');
    }
  };

  const bloqueadoInicial = row && Number(row.estado) !== 1;

  return (
    <Modal isOpen={isOpen} fade={false} className="custom-modal" backdrop="static" size="md">
      <ModalHeader className="modal-header">
        <div className="titulo">
          <h1>{row ? 'EDITAR' : 'NUEVO REGISTRO'}</h1>
          <Button className="close-btn" onClick={() => onClose(false)}>
            X
          </Button>
        </div>
      </ModalHeader>
      <div className="modal-body-footer">
        <ModalBody className="modal-body">
          <Form className="fila" onSubmit={(e) => e.preventDefault()}>
            <FormGroup>
              <Label>
                Colaborador: <span style={{ color: 'red' }}>*</span>
              </Label>
              <Input
                type="select"
                name="id_usuario"
                className="form-control"
                value={form.id_usuario}
                onChange={handleChange}
                disabled={bloqueadoInicial}
              >
                <option value="">Seleccionar</option>
                {(usuarios || []).map((o) => (
                  <option key={String(o.usuario_id)} value={String(o.usuario_id)}>
                    {o.nombre_completo || o.usuario_id}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label>
                Reclamo: <span style={{ color: 'red' }}>*</span>
              </Label>
              <Input
                type="textarea"
                name="reclamo"
                className="form-control"
                rows={4}
                value={form.reclamo}
                onChange={handleChange}
                disabled={bloqueadoInicial}
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Monto (S/): <span style={{ color: 'red' }}>*</span>
              </Label>
              <Input
                type="number"
                name="monto"
                className="form-control"
                step="0.01"
                min="0"
                value={form.monto}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Observaciones</Label>
              <Input
                type="textarea"
                name="observaciones"
                className="form-control"
                rows={3}
                value={form.observaciones}
                onChange={handleChange}
              />
            </FormGroup>
            {row && (
              <FormGroup>
                <Label>Estado</Label>
                <Input type="select" name="estado" className="form-control" value={form.estado} onChange={handleChange}>
                  {(estados || []).map((t) => (
                    <option key={String(t.tipo_id)} value={String(t.tipo_id)}>
                      {t.descripcion || t.tipo_id}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            )}
            <FormGroup>
              <div className="button-container">
                <Button className="button-custom" onClick={handleSubmit}>
                  {row ? 'ACTUALIZAR' : 'REGISTRAR'}
                </Button>
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
      </div>
    </Modal>
  );
}

export default ModalValidacionServicioForm;
